module.exports = __webpack_public_path__ + "img/ico_search--bl.e51d0549.svg";